var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.475 4.36425L6.90082 16.583C5.08723 17.4516 5.09772 18.6579 6.56808 19.1959L13.3907 21.7336L29.1764 9.85797C29.9228 9.31646 30.6048 9.60777 30.0442 10.2011L17.2547 23.964H17.2517L17.2547 23.9658L16.7841 32.3511C17.4736 32.3511 17.7778 31.974 18.1645 31.529L21.4784 27.6866L28.3715 33.7576C29.6425 34.5922 30.5553 34.1633 30.8716 32.3547L35.3965 6.92703C35.8597 4.71275 34.6876 3.71015 33.475 4.36425Z",
    fill: "url(#paint0_linear_1048_33685)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1048_33685",
    x1: 5.5,
    y1: 19.3251,
    x2: 36.8652,
    y2: 19.3208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00394562,
    stopColor: "#F44554"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3271E1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.2c0b1c5c6227e81ba93975f131141de5.svg";
export { ForwardRef as ReactComponent };